module.exports = __webpack_public_path__ + "static/img/Rolling Printing.dc6b1e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/Rolling Printing.jpg
// module id = A3Xc
// module chunks = 1